import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { Food, FoodPartial } from '../../../models/tracks/food';
import Button from '../../components/Button';

type Props = {
  foods: Food[];
  selected: Food[];
  onClick: (selected: Food) => void;
  onAdd: () => void;
};

const SearchResults = (props: Props) => {
  const [offsetTop, setOffsetTop] = useState<number>(0);

  const ref = useRef<HTMLDivElement>();
  useEffect(() => {
    setOffsetTop(ref.current.offsetTop);
  }, []);

  return (
    <div
      className={styles.body}
      ref={ref}
      style={{ height: `calc(100vh - ${offsetTop + 50}px)` }}
    >
      {props.foods.map((item) => {
        return (
          <div
            className={styles.item}
            onClick={() => {
              props.onClick(item);
            }}
          >
            <div className={styles.column}>
              <RenderIcon selected={props.selected} current={item.food} />
            </div>
            <div className={styles.column}>
              <div className={styles.meal_name}>{item.food.label}</div>
              <div className={styles.meal_measure}>100 g</div>
            </div>
            <div className={styles.column}>{item.food.nutrients.FAT}</div>
            <div className={styles.column}>{item.food.nutrients.CHOCDF}</div>
            <div className={styles.column}>{item.food.nutrients.PROCNT}</div>
            <div className={styles.column}>
              {item.food.nutrients.ENERC_KCAL}
            </div>
            <div className={styles.column} />
          </div>
        );
      })}
      {props.selected.length > 0 && (
        <Button
          onClick={() => {
            props.onAdd();
          }}
          type={'default'}
        >{`Add (${props.selected.length})`}</Button>
      )}
    </div>
  );
};

type IconProps = {
  selected: Food[];
  current: FoodPartial;
};

const RenderIcon = (props: IconProps) => {
  if (props.selected.length) {
    const isCurrentSelected = props.selected.find(
      (item) => item.food.foodId === props.current.foodId,
    );
    if (!isCurrentSelected) {
      return <img src="/assets/images/add_inactive.svg" alt="" />;
    }
    if (isCurrentSelected) {
      return <img src="/assets/images/add_active.svg" alt="" />;
    }
  }
  return null;
};

export default SearchResults;
